/***
*
*   MODAL
*   Display an overlay modal anywhere in your application by calling
*   context.modal.show() with an object containing the following props
*
*   PROPS
*   title: (optional)
*   text: message to the user (optional)
*   form: a form object (optional: see form docs for more information)
*   url: destination to send the form
*   method: HTTP post type
*   buttonText – text for the confirm button
*
**********/

import React, { useContext } from 'react';
import { ViewContext, Card, Form } from 'components/lib';
import { CSSTransition } from 'react-transition-group';
import LogoImageOnboard_1 from '../../assets/astronauta_1.svg';
import LogoImageOnboard_2 from '../../assets/astronauta_2.svg';
import LogoImageOnboard_3 from '../../assets/astronauta_3.svg';
import './modal.scss';

export function Modal(props){

  const context = useContext(ViewContext);

  return (
   <CSSTransition in appear timeout={ 0 } classNames='modal'>
      <div className='modal'
        onClick={(e) => e.target === e.currentTarget && context.modal.hide(true)}>

        <div className='modal-content' style={{minWidth: '490px'}}>
          <Card>

            { props.logo && props.logo === 'onboarding_1' &&
              <img width={100} height={100} src={ LogoImageOnboard_1 } alt='Logo' />
            }

            { props.logo && props.logo === 'onboarding_2' &&
              <img width={150} height={150} src={ LogoImageOnboard_2 } alt='Logo' />
            }

            { props.logo && props.logo === 'onboarding_3' &&
              <img width={130} height={130} src={ LogoImageOnboard_3 } alt='Logo' />
            }

            { props.title &&
              <header className='header-position'>
                <h1>{ props.title }</h1>
              </header>
            }

            { props.subtitle &&
              <header className='header-position'>
                <h2>{ props.subtitle }</h2>
              </header>
            }

            { props.text &&
              <p className='header-position'>{ props.text }</p>
            }

            { props.form &&
              <Form
                method={ props.method }
                url={ props.url }
                data={ props.clientInfo ? props.clientInfo : props.form }
                type_form={ props.type_form }
                onOnboard={ props.onOnboard }
                next={ props.next }
                back={ props.back }
                close={ props.close }
                onLocalStorage={ props.onLocalStorage }
                onForm= { props.onForm }
                buttonText={ props.buttonText }
                callback={ props.callback }
                leads_list = { props.data }
                campaignList={ props.campaignList }
                leadList={ props.leadList }
                btnShowAlert={ props.btnShowAlert ? props.btnShowAlert : null }
                closeForm={ props.closeModal }
                stream={ props.stream }
              />
            }
            { props.components &&
              props.components
            }
          </Card>
        </div>
      </div>
    </CSSTransition>
  );
}
